import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-seg{
  display:inline-flex;background:var(--neutral-100);border-radius:var(--radius-md);
  padding:3px;gap:2px;font-family:var(--font-sans);
}
.js-seg__btn{
  appearance:none;border:none;background:transparent;cursor:pointer;
  font-family:var(--font-sans);font-size:var(--text-sm);font-weight:var(--weight-semibold);
  color:var(--text-muted);padding:6px 16px;border-radius:calc(var(--radius-md) - 3px);
  transition:background var(--dur-fast) var(--ease-out),color var(--dur-fast) var(--ease-out),box-shadow var(--dur-fast) var(--ease-out);white-space:nowrap;
}
.js-seg__btn:hover{color:var(--text-strong)}
.js-seg__btn--active{background:var(--surface-card);color:var(--brand);box-shadow:var(--shadow-xs);font-weight:var(--weight-bold)}
.js-seg__btn:focus-visible{outline:none;box-shadow:var(--ring-brand)}
`;

export interface SegmentedOption {
  value: string;
  label: ReactNode;
}

export interface SegmentedControlProps extends Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  value: string;
  onChange: (v: string) => void;
  options: (string | SegmentedOption)[];
}

export function SegmentedControl({ value, onChange, options = [], className = "", ...rest }: SegmentedControlProps) {
  injectCss("js-seg-css", CSS);
  return (
    <div className={["js-seg", className].filter(Boolean).join(" ")} role="tablist" {...rest}>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        const active = v === value;
        return (
          <button
            key={v}
            type="button"
            role="tab"
            aria-selected={active}
            className={["js-seg__btn", active ? "js-seg__btn--active" : ""].join(" ")}
            onClick={() => onChange(v)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
